/* eslint-env browser */
import type { ReactNode } from 'react';
import React, { Children, useState, useLayoutEffect } from 'react';
import ReactDom from 'react-dom';
import { AFTER_APP } from './Portal.constants';
export type PortalProps = {
  children: ReactNode;
  name?: string;
};
export default function Portal({ children, name = AFTER_APP }: PortalProps) {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    setContainer(document.getElementById(name));
  }, [name]);

  if (!container) {
    return null;
  }

  return Children.count(children) ? ReactDom.createPortal(children, container) : null;
}
